import { render, staticRenderFns } from "./PitchCoinsPage.vue?vue&type=template&id=0b864926&scoped=true"
import script from "./PitchCoinsPage.vue?vue&type=script&lang=js"
export * from "./PitchCoinsPage.vue?vue&type=script&lang=js"
import style0 from "./PitchCoinsPage.vue?vue&type=style&index=0&id=0b864926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b864926",
  null
  
)

export default component.exports